<div class="createAccountForm" *blockUI="'createAccountUI'; template: blockTemplate">
  <app-weave-select-search
    [options]="officialCollectionsOptions"
    [data]="selectedOfficialCollectionRequestKey()"
    [label]="'Choose your accreditor'"
    [required]="true"
    [hideRequiredMarker]="true"
    (focusOut)="setSelectedOfficialCollectionRequestKey($event)"
  ></app-weave-select-search>
  @if(selectedOfficialCollectionRequestKey() && templateOptions.length > 1){
    <div class="selectEvent">
      <app-weave-select-search
        [hideRequiredMarker]="true"
        [options]="templateOptions"
        [data]="selectedTemplateRequestKey()"
        [label]="'What is your next reporting event?'"
        [required]="true"
        (focusOut)="setSelectedTemplateRequestKey($event)"
      ></app-weave-select-search>
    </div>
  }
  @if(selectedOfficialCollectionRequestKey() && selectedTemplateRequestKey()) {
    <div class="inputName">
      @if(isSelectedOfficialCollectionProgrammatic()) {
      <app-weave-input
        [appearance]="'fill'"
        [data]="programName()"
        [hideRequiredMarker]="true"
        label= "Program Name"
        [required]="true"
        placeholder="Enter the name of your program"
        (keyUp)="setProgramName($event)"
       ></app-weave-input>
      } @else {
        <app-weave-input
          [appearance]="'fill'"
          [data]="institutionName()"
          [hideRequiredMarker]="true"
          label= "Institution Name"
          [required]="true"
          placeholder="Enter the name of your institution"
          (keyUp)="setInstitutionName($event)"
        ></app-weave-input>
      }
    </div>
  }
  @if(errorMsg()){
    <div class="signup_error">
      {{ errorMsg() }}
    </div>
  }
  <div class="formActions">
    <app-weave-button
      [text]="'Create Account'"
      [classes]="'formAction button'"
      [disabled]="!selectedOfficialCollectionRequestKey() || ( !programName() && !institutionName()) || !selectedTemplateRequestKey()"
      (clicked)="onSave()"
    ></app-weave-button>
    <app-weave-button
      [classes]="'secondary button cancelBtn'"
      [text]="'Cancel'"
      (clicked)="onCancel()"
    ></app-weave-button>
  </div>
</div>
